import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import { Field, Formik } from "formik";
import React, { useState, useEffect } from "react";
import ReactSelect from "react-select";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,

  UncontrolledTooltip,
} from "reactstrap";

import Calendar from 'assets/icon/calendar-icon.svg';
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import HoverImage from 'react-hover-image/build';
import InfoIcon from 'assets/icon/AddWholeSaler.svg';
import moment from "moment";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { toast } from 'react-toastify';
import Question from 'assets/icon/icons8-question-mark.svg'
import Tooltip from 'react-tooltip-lite';
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import DeleteIcon from 'assets/icon/icon-icon-options-delete.svg';
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import DeleteHoverIcon from 'assets/icon/icon-icon-options-delete-hover.svg';
import NDCList from "components/NDCList";
import * as Yup from "yup";
import useAxios from "hooks/useAxios";
import { parse } from "@fortawesome/fontawesome-svg-core";
import Loader from "components/Loader";
import Attachments_hover from "assets/icon/icon-icon-options-attachment_hover.svg";
import Attachments from "assets/icon/icon-icon-options-attachment.svg";
import Drawer from "components/Drawer";
import Addattachments from "components/AddAttachmentsSerachOrder";
import ProgramNotes from "components/ProgramNotes";
import { First } from "react-bootstrap/esm/PageItem";
import { ModuleAccess } from "utils/moduleaccess";
import { dateFormate } from "utils/columns";
import useContextService from "hooks/useContextService";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import complete from "assets/icon/complete-icon.svg";
// import Deletetable from 'assets/icon/icon-icon-options-delete.svg';
// import DeleteHower from 'assets/icon/icon-icon-options-delete-hover.svg';
import Deletetable from 'assets/icon/download.svg';
import DeleteHower from 'assets/icon/download_hover.svg';


let hasDatePopupOpen = false;
let accountTypeData = [];
let accountNumberData = [];
let rowForEdit = {}
let rowsdata = [];
const EditPurchaseOrder = (props) => {

  const initialValues = {
    creditReturn: isCreditReturnChecked,
    ndc: "",
    accumulation: "",
    qtyordered: "",
    qtyreceived: "",
    qtybilled: "",
    packagesprice: "",
    totalOrdPrice: "",
    comment: "",
    drugName: ""
  };
  const {
    states: { searchOrder },
    setStates,
  } = useContextService();
  const { search, coveredEntity, searchTerms, claimStatusID } = searchOrder;
  const { coveredEntityIDs } = searchTerms;

  const { orgId, toggle, refetch, iseditflag, rowData, SelectedAccumulator } = props;
  //const { poNumber } = rowData;
   
  useEffect(() => {
    setPoid(rowData?.poid);
  }, [rowData])
  const API = useAxios();
  const [modal, setModal] = useState(false);
  const toggleScreen = () => setModal(!modal);
  //const [accountTypeData,setAccountTypeData] = useState([]);
  const [state, updateState] = useState({ rows: [], });
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const [isflag, setIsflag] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [orderDate, setOrderDate] = useState(null);
  const [receivedDate, setReceivedDate] = useState(rowData?.itemDateAckDate != null ? new Date(rowData?.itemDateAckDate) : null);
  const [invoiceDate, setInvoiceDate] = useState( rowData?.itemInvoicedDate != null ? new Date(rowData?.itemInvoicedDate) : null);
  const [poid, setPoid] = useState(null);
  const [invoiceid, setinvoiceid] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, Serror] = useState(false)
  const [selectedNdc, setSelectedNdc] = useState("");
  const [err, setError] = useState(false);
  const [wholesaler, setWholeSaler] = useState([]);
  const [selectedWhosaler, setSelectedWhosaler] = useState("");
  const [accountType, setAccountType] = useState([]);
  const [accountnum, setAccountnum] = useState([]);
  const [selectedAccountType, setAccountTypeSelected] = useState();
  const [selectedWhosalererror, setSelectedWhosalerError] = useState("");
  const [selectedaccountNumber, setSelectedaccountNumber] = useState("");
  const [orderstatus, setOrderstatus] = useState("");
  const [selectedNDC, setSelectedNDC] = useState(null);
  const [isCreditReturnChecked, setIsCreditReturnChecked] = useState(false);
  const [qtyBilled, setQtyBilled] = useState("");
  const [commentRowData, setCommentRowData] = useState({});
  const [isEditable, setIsEditable] = useState(false); // Track edit state
  const [isEditable1, setIsEditable1] = useState(false);
  const [data, setData] = useState([]);
  const [nDc, setNdc] = useState([]);
  const [AddAtachments, setAddAtachments] = useState(false);
  const [receivedBilled, setReceivedBilled] = useState(0);
  const [billqty, setBillQty] = useState(0);
  const [packageprices, setPackageprice] = useState(0);
  const [commentData,setCommetData] = useState("");
  const [sample, setSample] = useState()
  const [ndcexisterror, setndcexistErrors] = useState(false);
  const [invoiceDateError, setInvoiceDateError] = useState("");
  const [invoiceError, setInvoiceError] = useState(false);

  console.log(rowData,"rowdata Edit purchase")
  
  //const [rows, setRows] = useState([]);
  // const handleAddRow = (val) => {
  //   setRows([...rows, { id: Date.now(), Desc: '', qtyordered: '', qtyreceived: '', qtybilled: '', packagesprice: '', comment: '' }]);
  // };

  // const onHandleDelete = (id) => {
  //   setRows(rows.filter(row => row.id !== id));
  // };
  // const handelSelectWholeSaler = (e) => {
  //   // const { value } = e.target;
  //   // if (value.length > 0) {
  //   //   setSelectedWhosalerError("");
  //   // }
  //   // // console.log(value,"value")
  //   setSelectedWhosaler(value);
  //   setSelectedWhosaler(selectedWhosaler);
  // };

  const comepleteValidationChecking = () => {
     let hasError = false;
    if (invoiceDate == null && rowData.itemInvoicedDate == null) {
      setInvoiceDateError("Invoiced Date is a required field");
      hasError = true;
    }
    else {
      setInvoiceDateError("");
    }
    if (invoiceid == null && rowData.invoiceNumber == "") {
      setInvoiceError("Invoice# is a required field");
      hasError = true;
      // return true;
    }
    else {
      setInvoiceError("");
    }
    return hasError;
  }

  const handleChangePO = (e) => {
     
    const value = e.target.value;
    setPoid(value)
  }

  const validationSchema = Yup.object({

    ndc: Yup.string().required("NDC Description is a required field"),
    //accumulation: Yup.string().required('Required'),
    qtyordered: Yup.number()
      .when([], {
        is: () => !isCreditReturnChecked, // Check if Credit/Return is NOT checked
        then: Yup.number()
          .required('Qty Ordered is a required field')


          .test('is-valid-number', 'Qty Ordered must be a valid number', (value) => {
            return value === "" || !isNaN(value);
          }),
        otherwise: Yup.number().notRequired(), // Skip validation when Credit/Return is checked
      }),
    // qtyreceived: Yup.number()
    // .when([], {
    //   is: () => !isCreditReturnChecked, // Check if Credit/Return is NOT checked
    //   then: Yup.number()
    //      .required('Qty Received is required')
    //     .test('is-valid-number', 'Qty Received must be a valid number', (value) => {
    //       return value === "" || !isNaN(value);
    //     }),
    //   otherwise: Yup.number().notRequired(), // Skip validation when Credit/Return is checked
    // }),
    // qtybilled: Yup.string().required("Qty Billed is required"),
    // packagesprice: Yup.string().required("Package Price required"),
    // totalprice: Yup.string().required('Required'),
    // comment: Yup.string().required('Required')
  });




  const toggleEdit = (item, isEdit = true) => {
     
    let tempData = [...rows];
    tempData = tempData.map((row) => {
      // row.isEdit = false;
      if (row.ndc == item?.ndc && isEdit) {

        setIsEditable(row.ndc);
        setIsEditable1(true)
        row.isEdit = isEdit;
        rowForEdit = row.ndc;
      }
      return row;
    })
  };
  var acc = rowData?.accountType == "340B" ? 1001 : rowData?.accountType == "GPO" ? 1002 : 1003;
  useEffect(() => {
    fetchWholesaler();
    fetchAccountType();
    fetchAccountNumber(acc);
    // Serror(true)
  }, []);

  const manvalPharmacy = (rowData) => {
     
    setAddAtachments(!AddAtachments);
    setCommentRowData(rowData);
  }




  const oncancal = () => {
    setIsEditable(false);
  }

  const fetchWholesaler = async () => {
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/WholesalerTypes`, {
        hasDefaultURL: true,
      });
      if (data) {
        setWholeSaler(data);
      }
      // setLoading(false);
    } catch (error) {
      //setLoading(false);
      //. console.log(error.Message);
    }
  };
  const hasPermission = (code) => {
    return ModuleAccess("PCO", code);
  }
  const handleorder = async () => {
    
    // setOrderstatus("Complete");
    // if (validations()) {
    //  return true;
    // }
    if (comepleteValidationChecking()) {
      return true;
    }
    let orderdesc = "Complete"
    let payload = {};
     payload.InvoiceDate = invoiceDate != null ?  moment(invoiceDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss") : null;
      payload.ReceivedDate = receivedDate != null ?  moment(receivedDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss") : null;
    // payload.InvoiceDate = invoiceDate
    //                             ? invoiceDate
    //                             : rowData?.itemInvoicedDate
    //                             ? new Date(rowData.itemInvoicedDate)
    //                             : null;
                                
    // payload.ReceivedDate = receivedDate
    //                             ? receivedDate
    //                             : rowData?.itemDateAckDate
    //                             ? new Date(rowData.itemDateAckDate)
    //                             : null;
    payload.ItemOrderedDate = new Date(orderDate);
    //payload.AccountTypeID = selectedAccountType;
    payload.AccountTypeID = rowData.accountType == "340B" ? 1001 : rowData.accountType == "GPO" ? 1002 : 1003;
    payload.InvoiceNumber = invoiceid!=null?invoiceid : rowData.invoiceNumber;
    payload.DrugID = selectedNdc.id;
    payload.PONumber = poid.toString();
    payload.WholesalerId = rowData.wholesalerID;
    payload.AccountNumber = rowData.accountCode;
    payload.AddPOOrderModelfilter = state.rows;

    try {
      setLoading(true);
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/UpdatePurchaseOrder/${SelectedAccumulator}/${orderdesc}`, payload,
        { hasDefaultURL: true, }
      )
      if (data) {
        if (data.error) {
          toast.error(data.message);
          setLoading(false);
        }
        else {
          toast.success('Order Completed successfully');
          toggle();
          refetch(true);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handlesave = async () => {
     debugger;
    let orderstatusdesc = "save"
    let payload = {};
    // state.rows.qtyReceived = state.rows.qtyReceived == null ? 0 : state.rows.qtyReceived
    payload.WholesalerId = rowData.wholesalerID;
    payload.AccountTypeID = rowData.accountType == "340B" ? 1001 : rowData.accountType == "GPO" ? 1002 : 1003;
    payload.AccountNumber = rowData.accountCode;
    payload.PONumber = rowData.poid.toString();
    //payload.PONumber = rowData.poNumber;
    payload.InvoiceNumber = invoiceid!=null ? invoiceid: rowData?.invoiceNumber;
    payload.ItemOrderedDate = rowData.poDate;
    payload.AddPOOrderModelfilter = state.rows;
     payload.InvoiceDate =invoiceDate != null ?  moment(invoiceDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss") : null;
      payload.ReceivedDate = receivedDate != null ? moment(receivedDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss") : null;
    // payload.InvoiceDate = invoiceDate
    //                             ? invoiceDate
    //                             : rowData?.itemInvoicedDate
    //                             ? new Date(rowData.itemInvoicedDate)
    //                             : null;
                                
    // payload.ReceivedDate = receivedDate
    //                             ? receivedDate
    //                             : rowData?.itemDateAckDate
    //                             ? new Date(rowData.itemDateAckDate)
    //                             : null;
    // payload.InvoiceNumber = invoiceid;
    // payload.DrugID = selectedNdc.id;
    //  setOrderstatus("save");
    try {
      setLoading(true);
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/UpdatePurchaseOrder/${SelectedAccumulator}/${orderstatusdesc}`, payload,
        { hasDefaultURL: true, }
      )
      if (data) {
        if (data.error == true) {
          toast.error(data.message);
          setLoading(false);
        }
        else {
          toast.success('Order Updated successfully');
          toggle();
          refetch(true);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  // const handleReceiveDate = (receivedDate) => {
     
  //   // var recdate = moment(new Date(receivedDate)).format(
  //   //   'MM/DD/YYYY'
  //   // );
    
  //   setReceivedDate(rowData.itemDateAckDate);
  //   setReceivedDate(receivedDate);
  // };
    const handleReceiveDate = (receivedDate) => {
     
    // var recdate = moment(new Date(receivedDate)).format(
    //   'MM/DD/YYYY'
    // );
    if(receivedDate !== null){
       const revDate = new Date(receivedDate)
         setReceivedDate(receivedDate);
    }
    else{
       const revDate = new Date(rowData?.itemDateAckDate)
      setReceivedDate(revDate);
    }

   
  };
  const cancelorder = async () => {
     
    try {
      setLoading(true);
      const { data } = await API.get(`SBTenant/${orgId.tenantID}/PurchaseOrder/ordercancel/${rowData.poid}`,
        { hasDefaultURL: true, }
      )

      if (data) {
        setLoading(false);
        toggle();
        refetch(true);
      }
    }

    catch {

    }

  }
  const handleOrderDateRaw = (e) => {
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && orderDate !== null) {
      setOrderDate(null);
    }
    if (isValid) {
      handleOrderDate(e.target.value);
    }
  }

  const handleReceiveDateRaw = (e) => {
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && receivedDate !== null) {
      setReceivedDate(null);
    }

    if (isValid) {
      handleReceiveDate(e.target.value);
    }
  }

  const handleInvoiceDateRaw = (e) => {
    var mxdt = new Date(orderDate)
    var valdt = new Date();
    var val = e.target.value;
    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && invoiceDate !== null) {
      setInvoiceDate(null);
    }

    if (isValid && val <= valdt && val >= mxdt) {
      handleInvoiceDate(e.target.value);
    }
  }

  const handleInvoiceDate = (invoiceDate) => {
     
    // var invodate = moment(new Date(invoiceDate)).format(
    //   'MM/DD/YYYY'
    // );
    
    if (invoiceDate !== null) {
      const invd = new Date(invoiceDate)
      setInvoiceDate(invd);
      setInvoiceDateError("");
    }
    else
    {
       const invd = new Date(rowData?.itemInvoicedDate)
      setInvoiceDate(invd);
    }
    // setInvoiceDate(invoiceDate);
  };

  const validations = () => {

    if (wholeid == '' || wholeid === undefined || wholeaccountid === '' || wholeaccountid === undefined || orderDate == null || invoiceDate == null || orderinvoice === '' || orderinvoice === undefined) {
      setError(true);
      setWholeAccIdError(true);
      setInvoiceError(true);
      return true;
    }
    return false;
  }
  const fetchAccountNumber = async (value) => {
      
    try {
      const { data } = await API.get(
        `SBConfig/TypeStatus/AccountNumbers/${rowData?.wholesalerID}/${value}/${SelectedAccumulator[0]}`,
        { hasDefaultURL: true }
      );

      if (data) {
        for (var x in data) {
          accountNumberData.push({
            id: data[x].accountCode,
            description: data[x].accountCode,
          });
        }
        // if(accountTypeId)
        // {
        //   searchOrder.searchTerms.accountTypeId=accountTypeId;
        //   updateStates(searchOrder);
        // }
        setAccountnum(data)
      } else {
        setAccountnum([]);
      }
    } catch (err) { }
  };

  const fetchAccountType = async () => {

    try {
      const { data } = await API.get(`SBConfig/TypeStatus/accountType`, { hasDefaultURL: true });

      if (data) {

        for (var x in data) {
          accountTypeData.push({ "id": data[x].id, "description": data[x].description });
        }
        // if(accountTypeId)
        // {
        //   searchOrder.searchTerms.accountTypeId=accountTypeId;
        //   updateStates(searchOrder);
        // }
        setAccountType(data);
      }
      else {
        setAccountType([]);
      }
    }
    catch (err) {
    }
  }

  // const handleAccountTypeChange = (e) => {
  //   const { value } = e.target;
  //   //// setFieldValue('accountTypeId', value);
  //   setAccountTypeSelected(value);
  //   fetchAccountNumber(value);
  //   // searchOrder.searchTerms.accountTypeId = value;
  //   // updateStates(searchOrder);
  //   // console.log(value, "Account")
  // };
  const deleterecord = async (id) => {
    try {
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/Deleteitem/${rowData.poid}/${id}`,
        { hasDefaultURL: true, }
      )
      if (data) {

      }
    }
    catch {

    }

  }
  const onHandleDelete = (id) => {
     
    //deleterecord(id)
    const updatedRows = rows.filter((item) => item.ndc !== id);
    setState({
      rows: updatedRows
    });
    // setIsflag(true);
  };


  const { rows } = state;
  const handleSubmit = async (val, actions) => {
     
    if (state.rows.some(row => row.ndc == val.ndc.toString().padStart(11, '0'))){
      setndcexistErrors("NDC Already Exists!");
      return;
    }
   else{

    setndcexistErrors(false);
    const { resetForm, setSubmitting } = actions;
    val.id = "id" + Math.random().toString(16).slice(2);

    if (selectedNdc.length > 0) {
      setIsflag(true);
      Serror(false)
    }
    else {
      setIsflag(false);
      Serror(true)
    }

    //val.qtybilled = parseInt(val.qtybilled);
    val.packagesprice = val.packagesprice ? val.packagesprice : 0;
    val.qtybilled = val.qtybilled ? val.qtybilled : 0;
    val.qtyordered = val.qtyordered ? val.qtyordered : 0;
    val.qtyreceived = val.qtyreceived ? val.qtyreceived : 0;
    val.totalOrdPrice = val.packagesprice * val.qtybilled;
    // console.log("Before setState:", state.rows);

    setState({
      rows: [...state.rows, { ...val }]
    });
    // console.log("After setState:", state.rows);

    resetForm();

    setSubmitting(false);
    setSelectedNdc("");
    setQtyBilled("");
  }
    // if (ndc !== null) {
    //   Serror(false);
    //   //handleAccumulation(ndc, setFieldValue);
    // }
  };

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };


  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };


  const handleAccountNumberChange = (e) => {
    setSelectedaccountNumber(e.target.value)
  }

  const handleOrderDate = (orderDate) => {
     
    var ordate = moment(new Date(orderDate)).format(
      'MM/DD/YYYY'
    );
    setOrderDate(ordate);
  };

  const handleDateClick = (id) => {

    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleNdc = (ndc, setFieldValue) => {
     
    if (ndc !== null) {
      setSelectedNdc(ndc) !== ndc
      setFieldValue('ndc', ndc.id.toString().padStart(11,'0'));
      setFieldValue('Desc', ndc.description)
      Serror(false);
      //handleAccumulation(ndc, setFieldValue);
    }
    else {
      setSelectedNdc(null)
      setFieldValue('ndc', null);
      Serror(true);
    }

  };

  const handleQtyBilledChange = (value, setFieldValue) => {
    let qtyvalue = parseInt(value.target.value)
    if (isCreditReturnChecked) {
      setFieldValue("qtybilled", -Math.abs(qtyvalue));
      setQtyBilled(qtyvalue);

    } else {
      setFieldValue("qtybilled", Math.abs(qtyvalue));
      setQtyBilled(qtyvalue);

    }
  };

  useEffect(() => {
    fetchPOOrderDetails();
  }, []);

  const fetchPOOrderDetails = async () => {
     
    rowsdata = [];
    let payload = {};
    payload.CurrentPage = 1,
      payload.pageSize = 10,
      payload.orderBy = "poid",
      payload.order = "desc",
      payload.filters = [],
      payload.AccumulatorIDs = [SelectedAccumulator[0]],
      payload.AccountTypeID = 0,
      payload.POStatusID = 0,
      payload.Invoice = ""

    try {
      setLoading(true);
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/GetViewPurchaseOrderDetails/${rowData.poid}`, payload,
        { hasDefaultURL: true, }
      )
      const result = data;
       
      if (data) {
         
        for (var x in data.items) {
          if(data.items[x].itemStatus === "Item Open")
          {
          rowsdata.push({
            "ndc": data.items[x].ndc,
            "qtyordered": data.items[x].qtyOrder,
            "qtyreceived": data.items[x].qtyAck == null ? 0 : data.items[x].qtyAck,
            "qtybilled": data.items[x].qtyInvoiced,
            "packagesprice": data.items[x].pkgPrice,
            "totalOrdPrice": data.items[x].totalOrdPrice,
            "drugName": data.items[x].drugName,
            "comment": data.items[x].comment
          })
        }
        }
        updateState({ rows: rowsdata })
        // updateState(rows)
        setData(rowsdata);
        setLoading(false);
        // console.log(data.items, "Data in Edit")
      }
      else {
        setIsflag(true)
      }
    } catch (error) {
      setLoading(false);

    }
  };

  const handlereceievdChange = (value, setFieldValue) => {
    const inputValue = value.target.value;
     if (inputValue === "") {
    setFieldValue("qtyreceived", 0);
    setReceivedBilled(0);
    return;
  }
    const qtyvalue = parseInt(inputValue, 10);
    setFieldValue("qtyreceived", Math.abs(qtyvalue));
    setReceivedBilled(qtyvalue);
  };
  const handlbillChange = (value, setFieldValue) => {
    const inputValue = value.target.value;
     if (inputValue === "") {
    setFieldValue("qtybilled", 0);
    setBillQty(0);
    return;
  }const billvalue = parseInt(inputValue, 10);
    // let billvalue = parseInt(value.target.value);
    setFieldValue("qtybilled", Math.abs(billvalue));
    setBillQty(billvalue);
  }
  const handlepackagepriceChange = (value, setFieldValue) => {
     const inputValue = value.target.value;
     if (inputValue === "") {
    setFieldValue("packagesprice", 0);
    setPackageprice(0);
    return;
  }
    const qtypvalue = parseInt(inputValue, 10);
    //let qtypvalue = parseInt(value.target.value)
    setFieldValue("packagesprice", Math.abs(qtypvalue));
    setPackageprice(qtypvalue);
  };
  const savePanelUpdateRow = (item) => {
     
    for (var x in state.rows) {
      // console.log(state.rows[x].qtyReceived, 222)
      // console.log(billqty, 333)
      if (item?.ndc == state.rows[x].ndc) {
        state.rows[x].qtyreceived = receivedBilled ? receivedBilled : item.qtyreceived;
        state.rows[x].qtybilled = billqty ? billqty : item.qtybilled;
        state.rows[x].packagesprice = packageprices ? packageprices : item.packagesprice;
        state.rows[x].totalprice = packageprices * billqty;
        state.rows[x].comment = commentData ? commentData : item.comment;
      }
    }
    updateState({
      rows: [...state.rows]
    });
    setReceivedBilled(0);
    setBillQty(0);
    setPackageprice(0);
    setCommetData("");
    setIsEditable(false);
  }
  const handleinvoice = (e,items) => {
    
    var invoice = e.target.value;
     if (invoice !== null) {
      setinvoiceid(invoice);
      setInvoiceError("");
    }
    else
    {
      setinvoiceid(rowData?.invoiceNumber);
    }

    
  };
console.log(rowData,"Rowdata OK ????????????")
  return (
    <div>
      <Card>
        <CardBody>


          {loading && <Loader />}
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            enableReinitialize={true}
            children={(props) => {
              const {
                isSubmitting,
                handleSubmit,
                resetForm,
                setFieldValue,
                errors,
                touched,
              } = props;
              return (
                <>
                  <Row sm={5}>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="wholesalerName">Wholesaler/Vendor</Label>
                        <Field
                          className="required disabled"
                          id="wholesaler"
                          name="wholesaler"
                          type="select"
                          disabled
                          placeholder="Select WholeSaler "
                          autoComplete="off"
                          options={wholesaler}
                          // value={selectedWhosaler}
                          defaultoption={rowData?.wholesalerName}
                          // defaultValue={selectedWhosaler}
                          component={FormikSelectField}
                          keys={{
                            id: "wholesalerId",
                            label: "wholesalerName",
                          }}
                          //  onChange={(e) => handelSelectWholeSaler(e)}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4}>
                      {" "}
                      <FormGroup>
                        <Label for="accounttype">Account Type</Label>
                        <Field
                          className="required disabled"
                          id="accounttype"
                          name="accounttype"
                          type="select"
                          placeholder="Select"
                          disabled
                          autoComplete="off"
                          options={accountType}
                          //value={selectedAccountType}
                          component={FormikSelectField}
                          defaultoption={rowData?.accountType}
                          keys={{
                            id: "id",
                            label: "description",
                          }}
                          // onChange={(e) => handleAccountTypeChange(e)}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={3} sm={3} xs={6}>
                      {" "}
                      <FormGroup>
                        <Label for="accountNumber">Acct #</Label>
                        <Input
                          className="required disabled"
                          name="accountNumber"
                          id="accountNumber"
                          // type="select"
                          disabled
                          autoComplete="off"
                          options={accountnum}
                          component={FormikSelectField}
                          defaultValue={rowData?.accountCode}
                          keys={{
                            id: "id",
                            label: "description",
                          }}
                          // onChange={(e) => handleAccountNumberChange(e)}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={1} style={{ marginTop: 36 }}>
                      <Tooltip
                        content={
                          <div
                            className="tip-list-info"
                            style={{ position: "absolute", right: "0" }}
                          >
                            <p>
                              <strong>Acct # :</strong>
                              <span>
                                {" "}
                                If Wholesaler or Acct# is not found navigate
                                <br /> to Drug Catalog-- Wholesaler to add{" "}
                                <br /> Wholesaler Acct information. Please check
                                to add Credit Orders/Returns to the system.
                              </span>
                            </p>
                          </div>
                        }
                        direction="left"
                        tagName="span"
                        className="target"
                        tipContentClassName=""
                        zIndex={99999}
                      >
                        <span className="cursor-pointer text-decoration-underline">
                          <HoverImage
                            src={Question}
                            hoverSrc={Question}
                            style={{
                              width: "20px",
                              height: "20px",
                              // marginTop: "37px",
                            }}
                          ></HoverImage>
                        </span>
                      </Tooltip>
                    </Col>

                    <Col md={4}>
                      <FormGroup>
                        <Label for="PO">PO #</Label>
                        <Input
                          id="PO"
                          name="PO"
                          type="text"
                          placeholder="Enter PO"
                          autoComplete="off"
                          value={rowData?.filePONumber}
                          disabled={true}
                          // defaultValue={rowData.sourcePO}
                          //defaultValue={rowData?.filePONumber}
                          onChange={handleChangePO}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={4} className="required-date">
                      <FormGroup>
                        <Label>Order Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <DatePicker
                            id="orderDate"
                            name="orderDate"
                            value={dateFormate(rowData?.poDate)}
                            disabled
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Select a date"
                            autoComplete="off"
                            className="required disabled"
                            customInput={<ReactInputMask mask="99/99/9999" />}
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("orderDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {/* {err && orderDate === null && (
                      <div className="text-danger f-12">
                        Please select a Order Date
                      </div>
                    )} */}
                      </FormGroup>
                    </Col>

                    <Col md={3} className="notrequired-date-endDate">
                      <FormGroup>
                        <Label>Received Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <DatePicker
                            id="receivedDate"
                            name="receivedDate"
                            selected={receivedDate}
                            // minDate={(rowData?.poDate) ? new Date(rowData?.poDate) : null}
                            minDate={(rowData?.poDate && receivedDate) ? new Date(receivedDate) : null || (rowData?.poDate) ? new Date(rowData?.poDate) : null}
                            maxDate={new Date()}
                            onChange={(e) => {handleReceiveDate(e);}}
                            // value={dateFormate(rowData?.itemDateAckDate)}
                            disabled={isCreditReturnChecked}
                            onChangeRaw={handleReceiveDateRaw}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Select a date"
                            autoComplete="off"
                            className={
                              isCreditReturnChecked
                                ? "required disabled"
                                : "required"
                            }
                            customInput={
                              <ReactInputMask
                                mask="99/99/9999"
                                value={receivedDate}
                                // maskChar=''
                              />
                            }
                          />
                          <InputGroupText
                          // onClick={() => handleDateClick("receivedDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                      </FormGroup>
                    </Col>

                    <Col md={4} className="notrequired-date-endDate">
                      <FormGroup>
                        <Label>Invoiced Date</Label>
                        <InputGroup
                          onMouseLeave={handleMouseLeave}
                          style={{ zIndex: 99999 }}
                        >
                          <DatePicker
                            id="invoiceDate"
                            name="invoiceDate"
                            // selected={invoiceDate}
                           selected={
                              invoiceDate
                            }
                            minDate={(rowData?.itemDateAckDate && receivedDate) ? new Date(receivedDate) : null || (rowData?.itemDateAckDate) ? new Date(rowData?.itemDateAckDate) : null}
                          // minDate={(orderDate && receivedDate) ? new Date(receivedDate) : null || orderDate ? new Date(orderDate) : null}

                            maxDate={new Date()}
                            onChange={(e) => {
                              handleInvoiceDate(e);
                            }}
                            onChangeRaw={handleInvoiceDateRaw}
                            dateFormat="MM/dd/yyyy"
                            placeholderText="Select a date"
                            // value={dateFormate(rowData?.itemInvoicedDate)}
                            autoComplete="off"
                            // minDate={
                            //   receivedDate ? new Date(receivedDate) : new Date()
                            // }
                            // maxDate={new Date()}
                            customInput={
                              <ReactInputMask
                                mask="99/99/9999"
                                value={invoiceDate}
                              />
                            }
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("invoiceDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {invoiceDateError ? (
                          <div className="text-danger f-12">
                            {invoiceDateError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md={4} className="notrequired-date-endDate">
                      <FormGroup>
                        <Label for="Invoice Number">Invoice #</Label>
                        <Input
                          id="InoviceNumber"
                          name="InoviceNumber"
                          type="text"
                          placeholder="Invoice Number"
                          autoComplete="off"
                          defaultValue={invoiceid?invoiceid:(rowData?.invoiceNumber)}
                          // defaultValue={data.invoiceNumber}
                          // value={invoiceid}
                          onChange={(e) => {
                            handleinvoice(e,rows);
                          }}
                        />
                        {invoiceError ? (
                          <div className="text-danger f-12">
                            {invoiceError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>

                    <Col md={3} lg={3} sm={6} xs={6}>
                      {" "}
                      <FormGroup
                        style={{ marginTop: "25px", marginLeft: "10px" }}
                      >
                        <Label for="file.">Attach File...</Label>

                        <Button
                          className="text-primary text-decoration-none ms-2 p-2"
                          color="link"
                          onClick={() => manvalPharmacy(rowData)}
                          title="Attachment"
                        >
                          <HoverImage
                            src={Attachments}
                            hoverSrc={Attachments_hover}
                            alt=""
                          />
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="mb-3"
                        style={{
                          background: "#DBC8D8",
                          color: "#702C62",
                          padding: "8px 12px",
                          borderRadius: "4px",
                          width: "fit-content",
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <img src={InfoIcon}
                        alt="Info"
                        style={{
                          width: "16px",
                          height: "16px",
                          flexShrink: 0,
                          marginTop: "2px",
                        }} 
                        />
                        <p className="m-0 f-14 ms-2 ">
                          Complete is enabled after entering Invoiced
                          Date, Invoice #, Invoiced Qty and Package Price. If
                          this information is not yet available, the order can
                          be Saved with an Order Open status to allow future
                          edits.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </>
              );
            }}
          ></Formik>
          <Modal isOpen={modal} toggle={toggleScreen} className="custom-modal">
                      <ModalHeader className="modal-header-primary" toggle={toggleScreen}>
                        Do you wish to Cancel the Order?
                      </ModalHeader>
                      <ModalBody className="custom-modal-body" height="">
                        <p> Are you sure you want to cancel this order? All open items associated with this order will also be cancelled.</p>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="primary" className="modal-button" onClick={toggleScreen}>Cancel</Button>
                        <Button color="primary" className="modal-button" onClick={()=>{toggleScreen(); cancelorder();}} >OK</Button>
                      </ModalFooter>
                    </Modal>




          <div className="table-card">
            <div
              className="table-responsive"
              style={{ minHeight: "200px", borderRadius: "7px" }}
            >
              <table className="table theme-table">
                <thead style={{ borderRadius: "5px" }}>
                  <tr>
                    <th width="100">Options</th>
                    <th width="100">NDC</th>
                    <th width="160">NDC Description</th>
                    <th width="120">Qty Ordered</th>
                    <th width="120">Qty Received</th>
                    <th width="120">Qty Billed</th>
                    <th width="140">Package Price</th>
                    <th width="120">Total Price</th>
                    <th width="120">Comment</th>
                  </tr>
                </thead>
                <tbody>
                  <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    enableReinitialize={true}
                    children={(props) => {
                      const {
                        isSubmitting,
                        handleSubmit,
                        setSubmitting,
                        setFieldValue,
                        errors,
                        values,
                      } = props;
                      return (
                        <tr style={{ backgroundColor: "#f2f7fa" }}>
                          <td>
                            <Button
                              disabled={isSubmitting}
                              //onClick={handleAddRow}
                              onClick={handleSubmit}
                              type="submit"
                              color="link"
                            >
                              <FontAwesomeIcon
                                icon={faPlusCircle}
                                className="text-primary f-22"
                              />
                            </Button>
                          </td>

                          <td colSpan="2" style={{ paddingLeft: "1px", width: "200px", whiteSpace: "nowrap" }}>
                            <NDCList
                              requiredflag={true}
                              name="ndc"
                              onSelect={(value) => handleNdc(value, setFieldValue)}
                              selectedNDC={selectedNdc}
                            />
                             {ndcexisterror &&
                              <div style={{ color: "red" }}>
                                NDC already esits
                              </div>}

                          </td>
                          <style>
                            {`
                          input[type="number"]::-webkit-outer-spin-button,
                          input[type="number"]::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                            margin: 0;
                          }
                          input[type="number"] {
                            -moz-appearance: textfield;
                          }
                        `}
                          </style>

                          <td style={{ width: "75px" }}>
                            <Field
                              id="qtyordered"
                              name="qtyordered"
                              type="number"
                              autoComplete="off"
                              component={FormikInputField}
                              className={
                                isCreditReturnChecked
                                  ? "required disabled"
                                  : "required"
                              }
                              style={{ height: 42, width: 71, borderRadius: 5 }}
                              disabled={isCreditReturnChecked}
                            />
                          </td>

                          <td style={{ width: "75px" }}>
                            <Field
                              id="qtyreceived"
                              name="qtyreceived"
                              type="number"
                              autoComplete="off"
                              component={FormikInputField}
                              //   className={
                              //     isCreditReturnChecked
                              //       ? "required disabled"
                              //       : "required"
                              //  }
                              style={{ height: 42, width: 76, borderRadius: 5 }}
                              disabled={isCreditReturnChecked ||invoiceDate == null || invoiceid === ""}
                            />
                          </td>

                          <td style={{ width: "75px" }}>
                            <Input
                              id="qtybilled"
                              name="qtybilled"
                              type="number"
                              value={qtyBilled}
                              autoComplete="off"
                              component={FormikInputField}
                              className={
                                invoiceDate==null || invoiceid==""
                                  ? null
                                  : "required"
                              }
                              style={{ height: 42, width: 71, borderRadius: 5 }}
                              onChange={(e) => {
                                handleQtyBilledChange(e, setFieldValue);
                              }}
                              disabled={!isCreditReturnChecked && (invoiceDate == null || invoiceid === "")}
                            />

                          </td>

                          <td style={{ width: "75px" }}>
                            <Field
                              id="packagesprice"
                              name="packagesprice"
                              type="number"
                              autoComplete="off"
                              // className="required"
                              component={FormikInputField}
                              //onChange={(value) => handlepackagesprice(value, setFieldValue)}
                              style={{ height: 42, width: 71, borderRadius: 5 }}
                            />
                          </td>

                          <td style={{ width: "80px" }}>
                            {values.packagesprice && values.qtybilled ? (
                              <div>$
                                {(values.packagesprice * values.qtybilled).toFixed(
                                  2
                                )}{" "}
                                
                              </div>
                            ) : null}
                          </td>

                          <td>
                            <Field
                              id="comment"
                              name="comment"
                              type="textarea"
                              autoComplete="off"
                              style={{ height: 42, width: 80, borderRadius: 5 }}
                              component={FormikInputField}
                            // style={{ width: "160px" }}
                            />
                          </td>
                        </tr>
                      );
                    }}
                  />

                  {rows.map((item) => {
                    return (
                      <Formik
                        key={item.ndc}
                        initialValues={{
                          ndc: item.drugName,
                          //accumulation: item.accumulation,
                          qtyordered: item.qtyordered,
                          qtyreceived: item.qtyreceived,
                          qtybilled: item.qtybilled,
                          packagesprice: item.packagesprice,
                          totalOrdPrice: item.qtybilled * item.packagesprice,
                          comment: item.comment,
                        }}
                        //validationSchema={validationSchema}
                        enableReinitialize={true}
                        children={(props) => {
                          const { values, setFieldValue } = props;
                          // console.log(values, "valuesprops");
                          return (
                            <tr
                              key={item.ndc}
                              style={{ backgroundColor: "#f2f7fa" }}
                            >
                              <td>
                                <div className="d-flex align-items-center">
                                  <Button
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    hidden={isEditable === item.ndc}
                                    onClick={() => toggleEdit(item, true)}
                                    title="Edit"
                                  >
                                    <HoverImage
                                      src={EditIcon}
                                      hoverSrc={EditHoverIcon}
                                      alt=""
                                    />
                                  </Button>

                                  <Button
                                    hidden={isEditable !== item.ndc}
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    title="Save"
                                    onClick={() => savePanelUpdateRow(item)}
                                  >
                                    <HoverImage
                                      key="SaveIcon"
                                      src={SaveIcon}
                                      hoverSrc={SaveHoverIcon}
                                      alt=""
                                    />
                                  </Button>
                                  <Button
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    hidden={isEditable !== item.ndc}
                                    onClick={oncancal}
                                  >
                                    <HoverImage
                                      key="CancelIcon"
                                      src={CancleIcon}
                                      hoverSrc={CancleHoverIcon}
                                      alt=""
                                    />
                                  </Button>
                                  <Button
                                    className="text-primary p-0 text-decoration-none"
                                    color="link"
                                    onClick={() => onHandleDelete(item.ndc)}
                                    title="Delete"
                                    
                                  // hidden={true}
                                  >
                                    
                                    <HoverImage
                                    key="Delete"
                                      src={Deletetable}
                                      hoverSrc={DeleteHower}
                                      alt=""
                                    />
                                  </Button>
                                </div>
                              </td>
                              <td className="flex align-items-center">
                                {item.ndc}
                              </td>
                              <td>
                                {item.drugName ? item.drugName : item.Desc}
                              </td>


                              <td>
                                {values?.qtyordered}
                              </td>
                              {isEditable1 == true && isEditable === item.ndc ? (
                                <td>
                                  <Input
                                    id="qtyreceived"
                                    name="qtyreceived"
                                    type="number"
                                    // placeholder="sample"
                                    defaultValue={receivedBilled ? receivedBilled : item.qtyreceived}
                                    autoComplete="off"
                                    style={{ height: 42, width: 71, borderRadius: 5 }}
                                    onChange={(e) => {
                                      handlereceievdChange(e, setFieldValue);
                                    }}
                                    disabled={invoiceDate == null || invoiceid === ""}
                                  />
                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  {values?.qtyreceived}
                                  {/* {receivedBilled ? receivedBilled : values?.qtyreceived} */}
                                  {/* {values?.qtyreceived !== undefined && values?.qtyreceived === 0 ? values.qtyreceived : ''} */}

                                </td>
                              )}
                              {isEditable1 == true && isEditable === item.ndc ? (
                                <td>
                                  <Input
                                    id="qtybilled"
                                    name="qtybilled"
                                    type="number"
                                    defaultValue={billqty ? billqty : item.qtybilled}
                                    // value={item.qtybilled}
                                    autoComplete="off"
                                    style={{ height: 42, width: 71, borderRadius: 5 }}
                                    onChange={(e) => {
                                      handlbillChange(e, setFieldValue);
                                    }}
                                    className={invoiceDate==null || invoiceid=="" ? null : "required"}
                                    disabled={invoiceDate == null || invoiceid === ""}
                                  />
                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  {values?.qtybilled}
                                  {/* {values?.qtybilled !== undefined && values?.qtybilled === 0 ? values.qtybilled : values?.qtybilled} */}
                                </td>
                              )}

                              {isEditable1 == true && isEditable === item.ndc ? (
                                <td>
                                  <Input
                                    id="packagesprice"
                                    name="packagesprice"
                                    type="number"
                                    // value={packageprices ? packageprices : item.packagesprice}
                                    defaultValue={packageprices ? packageprices : item.packagesprice}
                                    autoComplete="off"
                                    style={{ height: 42, width: 83, borderRadius: 5 }}
                                    onChange={(e) => {
                                      handlepackagepriceChange(e, setFieldValue);
                                    }}
                                  />
                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  ${(values?.packagesprice).toFixed(2)}
                                  {/* {packageprices ? packageprices : values?.packagesprice} */}
                                  {/* {values?.packagesprice !== undefined && values?.packagesprice !== 0 ? values.packagesprice : ''} */}

                                </td>
                              )}

                              {/* <td>
                            {rowData.totalOrdPrice}
                            
                            {values.packagesprice && values.qtybilled ? (
                              <div>
                                {(
                                  values.packagesprice * values.qtybilled
                                ).toFixed(2)}
                                $
                              </div>
                            ) : null}
                          </td> */}
                              <td>
                                {item.totalprice && !(values.packagesprice && values.qtybilled) ? (
                                   <>
                                   ${(item.totalprice)}
                                   </>
                                ) : (
                                  <div>
                                    $
                                    {(values.packagesprice * values.qtybilled).toFixed(2)}
                                  </div>
                                )}
                              </td>
                              {isEditable1 == true && isEditable === item.ndc ? (
                                <td>
                                  <Input
                                    id="comment"
                                    name="comment"
                                    type="textarea"
                                    autoComplete="off"
                                    rows={1}
                                    defaultValue={commentData ? commentData : item.comment}
                                    //component={FormikInputField}
                                    onChange={(e) => {
                                      handleCommentChange(e, setFieldValue);
                                    }}
                                    style={{ height: 42, width: 80, borderRadius: 5 }}
                                  />
                                </td>
                              ) : (
                                <td className="flex align-items-center">
                                  {values?.comment}
                                </td>
                              )}
                            </tr>
                          );
                        }}
                      />
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{ float: "right" }} className="mt-3">
              <Button color="primary" className="reset" onClick={toggleScreen} hidden={!hasPermission('CO')} >
                <span className="right_5"><img src={cancel} alt="" /></span> Cancel Order
              </Button>

              <Button
                color="primary"
                onClick={handleorder}
                disabled={isflag == true || invoiceDate==null || invoiceid=="" || state.rows.length == 0}
                className="search"
              >
                <span className="right_5"><img src={complete} alt="" /></span> Complete
              </Button>
              <Button
                color="primary"
                className="search"
                onClick={handlesave}
                disabled={isflag == true || invoiceDate!=null || invoiceid!=""}
              >
                <span className="right_5"><img src={save} alt="" /></span> Save
              </Button>

            </div>
          </div>


        </CardBody>
      </Card>
      <Drawer
        direction="end"
        isOpen={AddAtachments}
        toggle={manvalPharmacy}
        size="lg"
        title="Add Attachments"
      >
        <ProgramNotes
          orgId={orgId}
          onClose={manvalPharmacy}
          selectedCoveredEntity={coveredEntityIDs}
          commentRowData={commentRowData}
        />
      </Drawer>
    </div>
  );
};

export default EditPurchaseOrder;

